interface IPermitions {
  ADMINISTRADOR: number
  CSNCONTRAPARTE: number
  CSNSEGURANCALOGICA: number
  CSNTI: number
  FORNECEDORADMINISTRADOR: number
  FORNECEDOROPERADORGST: number
  FORNECEDOROPERADORHIBRIDO: number
  FORNECEDOROPERADORNGT: number
  GSTANALISTA: number
  GSTNORMATIVO: number
  NGTANALISTA: number
  NGTNORMATIVO: number
}

export const PERMITIONS = Object.freeze<IPermitions>({
  ADMINISTRADOR: 1,
  CSNCONTRAPARTE: 6,
  CSNSEGURANCALOGICA: 8,
  CSNTI: 7,
  FORNECEDORADMINISTRADOR: 9,
  FORNECEDOROPERADORGST: 11,
  FORNECEDOROPERADORHIBRIDO: 12,
  FORNECEDOROPERADORNGT: 10,
  GSTANALISTA: 5,
  GSTNORMATIVO: 4,
  NGTANALISTA: 3,
  NGTNORMATIVO: 2
})
